export var CartPaymentMethodType;
(function (CartPaymentMethodType) {
    /** Paid via a Stripe transaction */
    CartPaymentMethodType["Stripe"] = "Stripe";
    /** The user paid using a PunchPass that they had purchased from us */
    CartPaymentMethodType["PunchPass"] = "PunchPass";
    /** The user paid using StoreCredit that they had received from us */
    CartPaymentMethodType["StoreCredit"] = "StoreCredit";
    /** The user paid by promising to do a {task} for us */
    CartPaymentMethodType["TaskExchange"] = "TaskExchange";
    /** The user received a PayItForwardTicket */
    CartPaymentMethodType["ClaimPayItForward"] = "ClaimPayItForward";
    /** The user has donated a PayItForwardTicket */
    CartPaymentMethodType["DonatePayItForward"] = "DonatePayItForward";
    /** The use is agreeing to pay us Cash at the door */
    CartPaymentMethodType["PromiseCash"] = "PromiseCash";
    /** This was added as a workaround for Jazz Attack requirements.
        They have physical punch passes they've given out for cash / venmo.
        They wanted the software to track them.
    */
    CartPaymentMethodType["PhysicalPunchPass"] = "PhysicalPunchPass";
    /** This is added for a temporary workaround for Free Bogo Tickets */
    CartPaymentMethodType["Free"] = "Free";
    /** For tickets that are manually issued by staff for free */
    CartPaymentMethodType["CompedByAdmin"] = "CompedByAdmin";
})(CartPaymentMethodType || (CartPaymentMethodType = {}));
export const PAYMENT_METHODS = Object.values(CartPaymentMethodType);
//# sourceMappingURL=payment-method.schema.js.map